import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

export const addCustomApplianceMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Add Custom Appliance',
		isVisible: ({ controller: { navigation, readonly }}): boolean => {
			return !readonly && navigation.displayMode !== DisplayMode.Overhead;
		},
		onClick: ({ context, position, controller }): void => {
			controller.publishRequestedAction('add_custom_appliance', context.id, {
				position
			});
		}
	}
};
